import $ from 'jquery'

const cartForm = $('form.cart')

if (cartForm.length > 0) {
  const qtyInput = cartForm.find('input.qty')
  const qtyText = cartForm.find('span#qty')
  const plusBtn = cartForm.find('span#plus')
  const minusBtn = cartForm.find('span#minus')
  if (qtyText.length > 0) {
    minusBtn.on('click', () => {
      if (parseInt(qtyInput.val()) > parseInt(qtyInput.attr('min'))) {
        qtyInput.val(parseInt(qtyInput.val()) - 1)
        qtyText.text(qtyInput.val())
      }
    })

    plusBtn.on('click', () => {
      if (parseInt(qtyInput.val()) < parseInt(qtyInput.attr('max'))) {
        qtyInput.val(parseInt(qtyInput.val()) + 1)
        qtyText.text(qtyInput.val())
      }
    })
  }
}
